import Axios from "axios";
import { setupCache, buildMemoryStorage } from "axios-cache-interceptor";
import uniqBy from "lodash/uniqBy";

const LIMIT = 15;

interface Tag {
  type: "hashtag" | "mention";
  value: string;
}

const hashtagsStorage = buildMemoryStorage();
const axiosCachedHashTags = setupCache(Axios.create(), {
  ttl: 15 * 60 * 1000,
  storage: hashtagsStorage,
});

export async function findAllHashtags(signal?: AbortSignal) {
  const response = await axiosCachedHashTags.request<Tag[]>({
    method: "get",
    url: `/tags/hashtags`,
    params: { limit: LIMIT },
    signal,
  });

  return uniqBy(response.data, (t: Tag) => t.value);
}

export async function findPrefixHashtags(prefix: string, signal?: AbortSignal) {
  if (!prefix) {
    return await findAllHashtags(signal);
  }
  const response = await axiosCachedHashTags.request<Tag[]>({
    method: "get",
    url: `/tags/hashtags/${window.encodeURIComponent(prefix)}`,
    params: { limit: LIMIT },
    signal,
  });

  return uniqBy(response.data, (t: Tag) => t.value);
}

export async function removeHashTag(tag: string) {
  await axiosCachedHashTags.delete(
    `/tags/hashtags/${window.encodeURIComponent(tag)}`
  );
  // NOTE: invalidate hashtags cache
  await hashtagsStorage.clear?.();
}

const mentionsStorage = buildMemoryStorage();
const axiosCachedMentions = setupCache(Axios.create(), {
  ttl: 15 * 60 * 1000,
  storage: mentionsStorage,
});

export async function findAllMentions(signal?: AbortSignal) {
  const response = await axiosCachedMentions.request<Tag[]>({
    method: "get",
    url: `/tags/mentions`,
    params: { limit: LIMIT },
    signal,
  });

  return uniqBy(response.data, (t: Tag) => t.value);
}

export async function findPrefixMentions(prefix: string, signal?: AbortSignal) {
  if (!prefix) {
    return await findAllMentions(signal);
  }
  const response = await axiosCachedMentions.request<Tag[]>({
    method: "get",
    url: `/tags/mentions/${window.encodeURIComponent(prefix)}`,
    params: { limit: LIMIT },
    signal,
  });

  return uniqBy(response.data, (t: Tag) => t.value);
}

export async function removeMention(tag: string) {
  await axiosCachedMentions.delete(
    `/tags/mentions/${window.encodeURIComponent(tag)}`
  );
  // NOTE: invalidate mentions cache
  await mentionsStorage.clear?.();
}
